<script context="module" lang="ts"></script>

<script lang="ts">
    export let isOpen = false;
    export let onOpen: (() => boolean | void | undefined) | undefined = undefined;
    let popup: HTMLElement;

    function open() {
        if (!onOpen || onOpen()) {
            isOpen = true;
            setTimeout(() => {
                let child = popup.firstElementChild as HTMLElement;
                if (!child) return;

                child.setAttribute("tabindex", "-1");
                child.focus({focusVisible: false} as any);
            })
        }
    }

    function onFocusOut(event: FocusEvent) {
        const newElement = event.relatedTarget as HTMLElement | null;
        const target = event.currentTarget as HTMLElement;
        if (!target.contains(newElement)) {
            isOpen = false;
        }
    }
</script>

<!----------------------------------------------------------------------------->

<slot name="button" {open}>
    <button on:click={open}>open</button>
</slot>
<div bind:this={popup} data-open={isOpen} on:focusout={onFocusOut}>
    <slot {isOpen}/>
</div>

<!----------------------------------------------------------------------------->

<style>
    [data-open="false"] {
        opacity: 0;
        display: none;
        /*display: contents;*/
    }

    [data-open="true"] {
        opacity: 1;
        display: contents;
    }
</style>
